import { Link } from "react-router-dom";
import React from "react";
import "../styles/ManPowering.css";
import man1 from "../assets/services/MAN 1.jpeg";
import man2 from "../assets/services/MAN 2.jpeg";

const services = [
  {
    title: "Workforce Planning",
    description:
      "Understand workforce requirements and create practical staffing plans based on your business needs.",
  },
  {
    title: "Recruitment Support",
    description:
      "Support candidate sourcing, screening and coordination to simplify your recruitment process.",
  },
  {
    title: "Contract Staffing",
    description:
      "Flexible staffing solutions for project-based, operational and business requirements.",
  },
  {
    title: "Temporary Staffing",
    description:
      "Workforce support for businesses that need additional employees for temporary requirements.",
  },
  {
    title: "Skill-Based Hiring",
    description:
      "Identify suitable candidates based on relevant skills, experience and role requirements.",
  },
  {
    title: "Workforce Coordination",
    description:
      "Support communication and coordination between businesses, teams and deployed workforce.",
  },
];

const process = [
  {
    number: "01",
    title: "Understand",
    description:
      "We understand the role, skills, workforce size and requirements of your business.",
  },
  {
    number: "02",
    title: "Source",
    description:
      "We identify suitable candidates and workforce options based on your requirements.",
  },
  {
    number: "03",
    title: "Select",
    description:
      "Candidates are coordinated and evaluated according to the required criteria.",
  },
  {
    number: "04",
    title: "Support",
    description:
      "We continue supporting workforce coordination after placement.",
  },
];

function ManPowering() {
  return (
    <main className="manpower-page">

      {/* ================= HERO ================= */}

      <section className="manpower-hero">
        <div className="manpower-hero-content">
          <span className="manpower-eyebrow">
            MAN POWERING
          </span>

          <h1>
            Build Teams
            <span>That Move Forward</span>
          </h1>

          <p>
            We help businesses find and coordinate suitable workforce
            solutions based on their roles, skills, operational needs
            and growth requirements.
          </p>

          <a
            href="#manpower-services"
            className="manpower-primary-btn"
          >
            Explore Services
            <span>→</span>
          </a>
        </div>

        <div className="manpower-hero-visual">
          <div className="manpower-hero-image">
            <img
              src={man1}
              alt="Professional team working together"
            />
          </div>
        </div>
      </section>


      {/* ================= INTRO ================= */}

      <section className="manpower-intro">
        <div className="manpower-section-label">
          <span>01</span>
          <p>OUR APPROACH</p>
        </div>

        <div className="manpower-intro-content">
          <h2>
            The right people can
            <span>move work forward</span>
          </h2>

          <div className="manpower-intro-grid">
            <p>
              Finding suitable people for the right roles is an important
              part of business growth. We support workforce planning and
              staffing processes with practical and flexible solutions.
            </p>

            <div className="manpower-feature-list">

              <div className="manpower-feature-item">
                <div className="feature-line"></div>

                <div>
                  <h3>Role Focused</h3>
                  <p>
                    Workforce solutions based on specific business
                    requirements and job roles.
                  </p>
                </div>
              </div>

              <div className="manpower-feature-item">
                <div className="feature-line"></div>

                <div>
                  <h3>Flexible Staffing</h3>
                  <p>
                    Options for temporary, contract and ongoing
                    workforce requirements.
                  </p>
                </div>
              </div>

              <div className="manpower-feature-item">
                <div className="feature-line"></div>

                <div>
                  <h3>Ongoing Support</h3>
                  <p>
                    Assistance and coordination throughout the staffing
                    process.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


      {/* ================= SERVICES ================= */}

      <section
        className="manpower-services"
        id="manpower-services"
      >
        <div className="manpower-section-heading">

          <div className="manpower-heading-label">
            <span>02</span>
            <p>OUR SERVICES</p>
          </div>

          <h2>
            Workforce solutions
            <span>built around your needs</span>
          </h2>

        </div>

        <div className="manpower-services-grid">

          {services.map((service, index) => (
            <article
              className="manpower-service-card"
              key={service.title}
            >
              <span className="manpower-card-number">
                {String(index + 1).padStart(2, "0")}
              </span>

              <h3>{service.title}</h3>

              <p>{service.description}</p>
            </article>
          ))}

        </div>
      </section>


      {/* ================= FEATURE ================= */}

      <section className="manpower-feature-section">

        <div className="manpower-feature-image">
          <img
            src={man2}
            alt="Workforce planning meeting"
          />
        </div>

        <div className="manpower-feature-content">

          <span className="manpower-eyebrow">
            WORKFORCE SOLUTIONS
          </span>

          <h2>
            Connect business needs
            <span>with the right skills</span>
          </h2>

          <p>
            We focus on understanding your requirements first and then
            supporting the sourcing, selection and coordination process
            around those needs.
          </p>

          <div className="manpower-mini-features">

            <div>
              <strong>01</strong>
              <span>Workforce Planning</span>
            </div>

            <div>
              <strong>02</strong>
              <span>Candidate Coordination</span>
            </div>

            <div>
              <strong>03</strong>
              <span>Staffing Support</span>
            </div>

          </div>

        </div>
      </section>


      {/* ================= PROCESS ================= */}

      <section className="manpower-process">

        <div className="manpower-section-heading">

          <div className="manpower-heading-label">
            <span>03</span>
            <p>OUR PROCESS</p>
          </div>

          <h2>
            From requirement
            <span>to workforce</span>
          </h2>

        </div>

        <div className="manpower-process-grid">

          {process.map((item) => (
            <div
              className="manpower-process-card"
              key={item.number}
            >
              <span className="process-number">
                {item.number}
              </span>

              <h3>{item.title}</h3>

              <p>{item.description}</p>
            </div>
          ))}

        </div>
      </section>


      {/* ================= CTA ================= */}

      <section className="manpower-cta">

        <div className="manpower-cta-content">

          <span>TECHLYNX INNOVATIONS</span>

          <h2>
            Looking for the right
            workforce?
          </h2>

          <p>
            Share your requirements with our team and explore
            suitable staffing solutions for your business.
          </p>

        </div>

        <Link
          to="/contact"
          className="manpower-cta-button"
        >
          Talk to Our Team
          <span>→</span>
        </Link>

      </section>

    </main>
  );
}

export default ManPowering;